import $ from '~/qwery';
import bean from '~/bean';

export default class RadioGroup {
    constructor(el) {
        if ($(el).data('radio-group'))
            return $(el).data('radio-group');
        $(el).data('radio-group', this);
        this.$el = $(el);
        const $checkedRb = this.$el.descendants('.b-radio[aria-checked=true]');
        if ($checkedRb.length) {
            this.checkRadioButton($checkedRb, false);
        } else {
            this.$el.descendants('.b-radio').first()
                .attr('tabindex', 0);
        }
        bean.on(this.$el[0], 'keydown', '.b-radio', e => {
            let $next;
            switch (e.key) {
            case 'ArrowUp':
            case 'ArrowLeft':
                $next = $(e.target).parent('li').prev().descendants('.b-radio');
                if ( ! $next.length)
                    $next = $(e.target).parent('li').next(':last-child')
                        .descendants('.b-radio');
                break;
            case 'ArrowDown':
            case 'ArrowRight':
                $next = $(e.target).parent('li').next().descendants('.b-radio');
                if ( ! $next.length)
                    $next = $(e.target).parent('li').prev(':first-child')
                        .descendants('.b-radio');
                break;
            case ' ':
                $next = $(e.target);
                break;
            }
            if ($next) {
                this.checkRadioButton($next, true);
                e.preventDefault();
            }
        });
        bean.on(this.$el[0], 'click', 'label.radio', e => {
            const $rb = $(e.target).selfOrParent('label.radio')
                .descendants('.b-radio');
            this.checkRadioButton($rb, true);
        });
        $('.b-radio', this.$el).each(rb => {
            bean.on(rb, 'focus', () => {
                bean.fire(this.$el[0], 'focus');
            });
            bean.on(rb, 'blur', () => {
                bean.fire(this.$el[0], 'blur')
            });
        });
    }

    radioButtonByElement(el) {
        return $(el).parent('li').descendants('.b-radio');
    }

    checkRadioButton(rb, focus) {
        const $rb = $(rb);
        const changed = $rb.attr('aria-checked') != 'true';
        if (changed) {
            $rb.parent('li').siblings().descendants('.b-radio').each(rb => {
                this._changeRadioButtonState(rb, false);
            });
            this._changeRadioButtonState($rb, true);
        }
        if (focus)
            $rb[0].focus();   // if we click on label
        if (changed)
            bean.fire(this.$el[0], 'change');
    }

    _changeRadioButtonState(rb, v) {
        const $rb = $(rb);
        if (v) {
            $rb.attr('tabindex', 0);
            $rb.attr('aria-checked', 'true');
        } else {
            $rb.removeAttr('tabindex');
            $rb.removeAttr('aria-checked');
        }
    }

    focus() {
        $('.b-radio[tabindex="0"]', this.$el).focus();
    }


    value() {
        const $rb = $('[aria-checked=true]', this.$el);
        return $rb[0] ? $rb.data('id') : null;
    }

    errorState(errorState) {
        if (errorState != null) {
            $('.b-radio', this.$el)[
                errorState ? 'addClass' : 'removeClass'
            ]('has-error');
            this._errorState = errorState;
        }
        return this._errorState;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/radio-group.js